export const getFileExtension = (file: File): string => {
  const ext = file.name.split('.').pop()?.toLowerCase() || '';
  return ext === 'jpg' ? 'jpeg' : ext;
};

export const getFileExtensionFromUri = (uri: string): string => {
  const lastSegment = uri.split('/').pop() || '';
  const ext = lastSegment.includes('.') ? lastSegment.split('.').pop()!.toLowerCase() : '';
  return ext === 'jpg' ? 'jpeg' : ext;
};
